import React, { useState } from 'react';

import { FormInput } from '@/components/shared/Inputs';
import { Blurb } from '@/components/shared/Inputs/Blurb';
import { Label } from '@/components/shared/Inputs/Label';
import { SingleActionLayout } from '@/components/shared/SingleActionLayout/SingleActionLayout';
import { TeamSong } from '@/graphql';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { AddCustomSongDisplayProps } from '../AddCustomSong';
import styles from './YouTubeUrl.module.scss';

type FormSchema = {
	youtubeId?: string;
};

type Props = {
	teamSong: Partial<Pick<TeamSong, 'youtubeId'>>;
	onSubmit: (values: { youtubeId: TeamSong['youtubeId'] }) => void;
};

const validationSchema: Yup.SchemaOf<FormSchema> = Yup.object().shape({
	youtubeId: Yup.string()
		.optional()
		.matches(/^(?=https:\/\/).+(?=youtu).+/, 'The URL must be valid')
		.max(500, 'Can not be more than 500 characters'),
	// youtubeId: Yup.string().required('Please enter a valid url'),
});

export const YouTubeUrl: React.FC<Props> = ({ teamSong, onSubmit }) => {
	const { youtubeId } = teamSong;
	const [touched, setTouched] = useState(false);
	const initialValues: FormSchema = {
		youtubeId: youtubeId || '',
	};
	return (
		<Formik
			key="asaphSignUn"
			initialValues={initialValues}
			validationSchema={validationSchema}
			onSubmit={(values) => {
				onSubmit({
					youtubeId: values.youtubeId || null,
				});
			}}
		>
			{({ handleSubmit, handleChange, values, errors, isValid }) => (
				<SingleActionLayout
					actionLabel="Save YouTube URL"
					actionDisabled={!isValid || !touched}
					onActionClick={handleSubmit}
				>
					<form
						onSubmit={handleSubmit}
						id="asaphSignIn"
						className={styles['root']}
					>
						<Label>Song YouTube URL</Label>
						<FormInput
							placeholder="Enter url"
							name="youtubeId"
							id="youtubeId"
							autoComplete="off"
							value={values.youtubeId}
							onChange={(e) => {
								setTouched(true);
								handleChange(e);
							}}
							error={!!errors.youtubeId}
						/>
						{errors.youtubeId && (
							<Blurb isError>{errors.youtubeId}</Blurb>
						)}
						<Blurb>
							To copy song URL, view your song on YouTube, then
							click Share &gt; Copy. Alternatively, you can copy
							the link from the field. Note that the Start at
							option is also supported.
						</Blurb>
					</form>
				</SingleActionLayout>
			)}
		</Formik>
	);
};
